import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=07b9bf37&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=js&"
export * from "./NotificationList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=07b9bf37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9bf37",
  null
  
)

export default component.exports